import React from 'react'
import hot1 from '../../img/hot1.png';
import chain from '../../img/chain.png';
// import Countdown from './Countdown';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Chart from './Chart';
import { BsTwitter, BsYoutube } from "react-icons/bs";
import { IoIosSend, } from "react-icons/io";
import { FaFacebookF, } from "react-icons/fa";
import { TbWorld, } from "react-icons/tb";
const socialData = [
    {
        id: 0,
        href: 'https://cloudpet.io',
        icon: <TbWorld />,
    },
    {
        id: 1,
        href: 'https://twitter.com/CloudPetO',
        icon: <BsTwitter />,
    },
    {
        id: 2,
        href: 'https://t.me/CloudPet_ChatRoom',
        icon: <IoIosSend />,
    },
    {
        id: 3,
        href: 'https://t.me/CloudPet_Channel',
        icon: <IoIosSend />,
    },
]

const LaunchpadDetails = ({
    balance,
    unlockedTokens,
    userStakes,
    earnings,
    burntTokens,
    locked,
    liquidityTokens,
    userPurchased,
    idoTokens,
    purchased,
    valueAmount,
    onChangeAmount,
    onClickDeposit,
    onClickWithdraw,
    onClickClaim,
    userstakedAmount,
    titleMain,
}) => {
    const now = (earnings / 25000) * 100
    return (
        <div className='launchpad-details-area pb-5'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="details-wallet border-dd">
                            <div className="details-wallet-header d-flex align-items-center gap-3">
                                <img src={`https://i.ibb.co/RQK19D9/cpetlogo.png`} height={70} alt="image" />
                                <div className="text">
                                    <div className="h4 text-white">Cloud Pet</div>
                                    <span className='text-p'>BUSD / CPET</span>
                                </div>
                            </div>
                            <div className="input-wallet">
                                <input
                                    onChange={onChangeAmount}
                                    value={valueAmount}
                                    type="number" placeholder='Amount' />
                            </div>
                            <div className="buttons">
                                <div id='akslfhsafh' className='d-sm-flex d-lg-block d-xl-flex justify-content-between align-items-center mb-2'>
                                    <button onClick={onClickDeposit} className='btn-lg'>{titleMain}</button>
                                    <button onClick={onClickClaim}className='btn-lg'>CLAIM</button>
                                </div>
                            </div>
                            <div className="how-to text-lg-end">
                                <p className='text-p'>How To Participate?</p>
                            </div>
                            <div className="calculation">
                                <div className="h2 fw-light text-c">1 BUSD = 4,000,000 CPET</div>
                                <span className='text-p text-transform'>1 CPET = $0.00000025</span>
                            </div>
                            <div className="h5 fw-light text-white pb-2">Whitelist : Whitelist is live</div>
                            <div className="presales-progress">
                                <span className='text-c fs-13'>Progress {now}%</span>
                                <ProgressBar now={now} />
                                <div className="d-flex">
                                    <div className='text-2 fs-13'> BUSD </div>
                                    <div className='text-white ms-auto fs-13'><span className='text-c'>{earnings} / </span> 25,000 BUSD</div>
                                </div>
                            </div>
                            <div className="text-center">
                                <button className='btn-lg'>Allocation : {userStakes} / {purchased} BUSD</button>
                            </div>
                        </div>
                        <div className="ido-details border-dd">
                            <div className="title text-white fs-5 text-center fw-semibold">IDO Details</div>
                            <hr />
                            <ul>
                                <li className='text-white'>Staked AVN: <span className='text-c'>{userstakedAmount}</span></li>
                                <li className='text-white'>Price IDO: <span className='text-c'>$0.00000025</span></li>
                                <li className='text-white'>Purchased Tokens: <span className='text-c'>{userPurchased}</span></li>
                                <li className='text-white'>Tokens for IDO: <span className='text-c'>300,000,000,000 CPET</span></li>
                                <li className='text-white'>Whitelisted: <span className='text-c'>20</span></li>
                                <li className='text-white'>Softcap: <span className='text-c'>12.5K BUSD</span></li>
                                <li className='text-white'>Hardcap: <span className='text-c'>25K BUSD</span></li>
                                <li className='text-white'>IDO Start: </li>
                                <li className='text-white'>IDO Ends: </li>
                                <li className='text-white'>Tokens for Liquidity: <span className='text-c'>150,000,000,000 CPET</span></li>
                            </ul>
                        </div>
                        <div className="chart-details border-dd">
                            <div className="title text-white fs-5 text-center fw-semibold">Tokenomics Supply Allocation</div>
                            <hr />
                            <div className="chart-text">
                                <Chart exData={[idoTokens, locked, liquidityTokens, unlockedTokens, burntTokens]} />
                            </div>
                            <div className="h6 text-white mt-3">Locked Platform:<span className='text-c'> Unicrypt</span> </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="details-right border-dd">
                            <div className="chain-img">
                                <img src={chain} width="150" alt="logo" />
                            </div>
                            <div className="details-right-header d-flex gap-2 align-items-start">
                                <img src={`https://i.ibb.co/RQK19D9/cpetlogo.png`} height={70} alt="image" />
                                <div className="text">
                                    <div className="h5 text-white">Cloud Pet</div>
                                    <ul className="social d-flex justify-content-lg-start gap-2">
                                        {socialData.map((item) => (
                                            <li key={item.id}><a href={item.href}>{item.icon}</a></li>
                                        ))}
                                    </ul>
                                    <ul className='btn-audit'>
                                        <li><a href="https://github.com/ContractChecker/audits/blob/main/CloudPet_Token_0xA4904cc19c4Fd9BF3152ff96Cdf72a8F135B5286_Smart_Contract_Security_Audit_By_ContractChecker.pdf">audit</a></li>
                                        <li><a href="https://github.com/solidproof/projects/tree/main/CloudPet">KYC</a></li>
                                        <li><a href="https://bscscan.com/token/0xA4904cc19c4Fd9BF3152ff96Cdf72a8F135B5286">Contract</a></li>
                                        <li><a href="https://github.com/ContractChecker/SAFU/blob/main/CLOUD_PET_0xA4904cc19c4Fd9BF3152ff96Cdf72a8F135B5286_SAFU_Certificate_By_ContractChecker.pdf">SAFU</a></li>
                                    </ul>
                                </div>
                            </div>
                            <p>
                                Cloud pet is built on Binance smart chain to provides solution to new and existing pet, our mission is to rescue pets in need, and reach out to abandoned pet and Carter for them to make them feel loved by their father.

                                Cloud pet brings crypto adoption to the main stream with new concept such as payment system, NFTs  marketplace, NFT Minting, Crypto wallet, online shopping mall and decentralized exchange and  chart tools
                            </p>
                            <p>This sale is under the <a href="https://drive.google.com/file/d/1mlqGSKyrNsQ4gyGQ126T4PEer4squpDq/view">AVNPad Terms and Conditions.</a></p>
                            <p><a href="#">AVNPad Eligibility Tiers</a></p>
                            <div className="title h5 text-white text-center mt-5">Cloud Pet Token Details</div>
                            <hr />
                            <ul className='text-white lists-dd'>
                                <li>Token Name: <span className='text-c fw-semibold'>Cloud Pet</span></li>
                                <li>Token Ticker: <span className='text-c fw-semibold'>Cpet</span></li>
                                <li>Type: <span className='text-c fw-semibold'>BEP-20</span></li>
                                <li>Contract Address:<span className='text-c fw-semibold'> 0xA4904cc19c4Fd....f72a8F135B5286</span></li>
                                <li>Initial Supply:<span className='text-c fw-semibold'> 1,000,000,000,000</span></li>
                                <li>Decimal: <span className='text-c fw-semibold'>18</span></li>
                            </ul>
                            <div className="title h5 text-white text-center mt-5">Token Distribution</div>
                            <hr />
                            <ul className='text-white lists-dd'>
                                <li>Distribution: <span className='text-c fw-light'>Claimed on AVNPad</span></li>
                                <li>Liquidity: <span className='text-c fw-light'>60% reserved for liquidity</span></li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default LaunchpadDetails
